function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15 2c.513 0 .936.386.993.883L16 3v1h5c.513 0 .936.386.993.883L22 5v14c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V5c0-.552.448-1 1-1h5V3c0-.552.448-1 1-1 .513 0 .936.386.993.883L10 3v1h4V3c0-.552.448-1 1-1zM8 6H4v12h16V6h-4v3c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L14 9V6h-4v3c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L8 9V6z"
});

var SvgAgenda = function SvgAgenda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgenda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agenda.425db69c.svg";
export { ForwardRef as ReactComponent };